import { Form } from "@/components/ui/form";
import { useEditForm } from "@/features/Edit/hooks";
import { FormActionsNew } from "@/features/FormCard/Actions";
import { NewDiff } from "@/features/FormCard/NewDiff";
import {
  CancelConfirmationModal,
  ConfirmationModal,
} from "@/features/FormCard/Modals";
import { Card, CardBody, CardFooter, CardHeader, Divider } from "@heroui/react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  normalizeVersionPayload,
  versionFormSchema,
  VersionsFormFields,
} from "./form";

const client = "instit-quantilia";
const table_name = "versions";

export function VersionsNew() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const {
    form,
    handleReset,
    onSubmit,
    confirmUpdate,
    cancelUpdate,
    isConfirmationModalOpen,
    isDeleteModalOpen,
    openDeleteModal,
    closeDeleteModal,
    isUpdating,
    changedFields,
  } = useEditForm({
    client,
    table_name,
    FormSchema: versionFormSchema,
    adjustData: normalizeVersionPayload,
    isNew: true,
    disable_translations_request: true,
  });

  const navigateToList = () => {
    navigate(-1);
  };

  return (
    <div className="grid place-items-center h-full w-full">
      <div className="flex justify-center w-full max-w-card">
        <Card className="p-4 bg-white w-full">
          <Form {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)}>
              <CardHeader className="text-lg font-bold text-gray-700">
                {t("new_version", { defaultValue: "New version" })}
              </CardHeader>
              <Divider />
              <CardBody className="flex flex-col gap-4">
                <VersionsFormFields
                  control={form.control}
                  table_name={table_name}
                />
              </CardBody>
              <CardFooter>
                <FormActionsNew
                  onReset={handleReset}
                  onDelete={openDeleteModal}
                />
              </CardFooter>
            </form>
          </Form>

          <ConfirmationModal
            isOpen={isConfirmationModalOpen}
            isLoading={isUpdating}
            onClose={cancelUpdate}
            onConfirm={confirmUpdate}
            title={t("confirm_create")}
          >
            {changedFields ? NewDiff(changedFields, []) : "No changes detected"}
          </ConfirmationModal>

          <CancelConfirmationModal
            isOpen={isDeleteModalOpen}
            onClose={closeDeleteModal}
            onCancel={navigateToList}
          />
        </Card>
      </div>
    </div>
  );
}
